<template>
  <div>
    <Progress />
    <h1 class="text-center mt-10">{{ $t('pageContact.header') }}</h1>
    <p class="text-center mt-5">{{ $t('pageContact.subHeader') }}</p>
    <v-container>
      <FormCustomer />
      <Loader v-if="this.user.loading" />

      <v-row no-gutters>
        <div class="col-6">
          <ProgressButton
            :label="{ text: this.text.buttonBack, alias: 'Customer-button--back', page: 'customer-info', action: 'previous' }"
            :step="{ number: 1 }"
          />
        </div>
        <div class="col-6">
          <div class="float-right">
            <StateButton :disabled="disableBtn" :label="this.text.buttonNext" @btn-click="submitClick" />
          </div>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import localizationTexts from '@/localization/texts.json';
import Progress from '@/components/Progress.vue';
import FormCustomer from '@/components/FormCustomer.vue';
import Loader from '@/components/Loader.vue';
import ProgressButton from '@/components/ProgressButton.vue';
import StateButton from '@/components/StateButton.vue';
import helpers from '@/settings/helpers';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'Customer',
  components: {
    FormCustomer,
    Loader,
    Progress,
    ProgressButton,
    StateButton
  },
  beforeMount() {
    if (
      this.user.kilometers > 0 &&
      this.user.car.registrationplate !== undefined &&
      this.user.department.departmentid !== undefined &&
      this.user.services.length > 0 &&
      this.user.datetime.date !== '' &&
      this.user.datetime.arrival !== ''
    ) {
      this.$store.dispatch('user/initStep', 3);
    } else if (this.user.step === 0) {
      this.$router.push({ name: 'Home' });
    } else if (this.user.step === 1) {
      this.$router.push({ name: 'Service' });
    } else if (this.user.step === 2) {
      this.$router.push({ name: 'Appointment' });
    }
  },
  mounted() {
    helpers.sendScroll(this.user.config.container, 0, this.user.config.host);
    this.text.buttonBack = localizationTexts[this.user.config.language].button.back;
    this.text.buttonNext = localizationTexts[this.user.config.language].button.next;

    // fill out form with data in case user navigates back
    if (this.user.info.firstname) {
      this.localFirstname = this.user.info.firstname;
    }
    if (this.user.info.lastname) {
      this.localLastname = this.user.info.lastname;
    }
    if (this.user.info.address) {
      this.localAddress = this.user.info.address;
    }
    if (this.user.info.zipcode) {
      this.localZip = this.user.info.zipcode;
    }
    if (this.user.info.city) {
      this.localCity = this.user.info.city;
    }
    if (this.user.info.email) {
      this.localEmail = this.user.info.email;
    }
    if (this.user.info.phone) {
      this.localPhone = this.user.info.phone;
    }
    if (this.user.info.accepted) {
      this.localAccept = this.user.info.accepted;
    }
    this.checkBtn();
  },
  data() {
    return {
      text: {
        buttonBack: '',
        buttonNext: ''
      },
      disableBtn: true,
      localFirstname: '',
      localLastname: '',
      localAddress: '',
      localZip: '',
      localCity: '',
      localEmail: '',
      localPhone: '',
      localAccept: false
    };
  },
  methods: {
    submitClick() {
      this.$store.dispatch('user/initValidation', false);
      helpers.sendGTM({ event: 'easybooking-click', eventCategory: 'customer-info', eventAction: 'next' }, this.user.config.host);
      this.$router.push({ name: 'Confirmation' });
    },
    checkBtn() {
      // culture validation rules
      const emailCheck = RegExp(this.$store.getters['user/user'].config.prop.email);
      const zipCheck = RegExp(this.$store.getters['user/user'].config.prop.zip);
      const phoneCheck = RegExp(this.$store.getters['user/user'].config.prop.phone);

      if (
        this.localFirstname &&
        this.localFirstname.trim().length > 0 &&
        this.localLastname &&
        this.localLastname.trim().length > 0 &&
        this.localAddress &&
        this.localAddress.trim().length > 0 &&
        zipCheck.test(this.localZip) &&
        this.localCity.trim().length > 0 &&
        emailCheck.test(this.localEmail) &&
        phoneCheck.test(this.localPhone) &&
        this.localAccept === true
      ) {
        this.disableBtn = false;
      } else {
        this.disableBtn = true;
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    firstname() {
      return this.user.info.firstname;
    },
    lastname() {
      return this.user.info.lastname;
    },
    address() {
      return this.user.info.address;
    },
    zipcode() {
      return this.user.info.zipcode;
    },
    city() {
      return this.user.info.city;
    },
    email() {
      return this.user.info.email;
    },
    phone() {
      return this.user.info.phone;
    },
    accept() {
      return this.user.info.accepted;
    }
  },
  watch: {
    firstname(newValue) {
      this.localFirstname = newValue;
      this.checkBtn();
    },
    lastname(newValue) {
      this.localLastname = newValue;
      this.checkBtn();
    },
    address(newValue) {
      this.localAddress = newValue;
      this.checkBtn();
    },
    zipcode(newValue) {
      this.localZip = newValue;
      this.checkBtn();
    },
    city(newValue) {
      this.localCity = newValue;
      this.checkBtn();
    },
    email(newValue) {
      this.localEmail = newValue;
      this.checkBtn();
    },
    phone(newValue) {
      this.localPhone = newValue;
      this.checkBtn();
    },
    accept(newValue) {
      this.localAccept = newValue;
      this.checkBtn();
    }
  }
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
